// Similar to JSON.stringify but limited to a specified depth (default 1)
export const stringify =
  (depth: number) =>
  (obj: Record<string, any>): string => {
    if (depth === undefined) {
      depth = 1; // default
    }
    return !obj
      ? JSON.stringify(obj)
      : typeof obj === 'object'
        ? '{' +
          (depth < 1
            ? '?'
            : Object.keys(obj)
                .map((k) => k + ': ' + stringify(depth - 1)(obj[k]))
                .join(', ')) +
          '}'
        : JSON.stringify(obj);
  };
